import React from 'react';
import TodaysOccupancy from './DashboardAllGraph/TodaysOccupancy';
import RevnueFlow from './DashboardAllGraph/RevenueFlow';
import AllOccupancyGraph from './DashboardAllGraph/AllOccupancyGraph';
import { Box, Grid, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from "react-router-dom";

const SpeedometerGauge1 = () => {
  const navigate = useNavigate();

  const handleClickList = () => {
    navigate('/upcoming-checkin')
  };

  const handclickCheckout = () => {
    navigate('/upcoming-checkout')
  };

  const handleOccupancy = () => {
    navigate("/occupancy-report")
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          maxWidth: '150vw',
          overflowX: 'hidden',
          boxSizing: 'border-box', p: 2, fontFamily: 'Roboto, sans-serif', color: '#1f2937', mb: 0
        }}
      >
        <Grid container spacing={2} sx={{ mb: -10 }}>
          <Grid item xs={12} md={6}>
            <TodaysOccupancy />
          </Grid>
          <Grid item xs={12} md={6}>
            <RevnueFlow />
          </Grid>
        </Grid>
        <Box sx={{ mt: 2 }}>
          <AllOccupancyGraph />
        </Box>
        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                borderRadius: 2,
                background: "#ffffff",
                border: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 3px 12px rgba(0,0,0,0.06)",
                transition: "all 0.25s ease",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "6px",
                  background: "linear-gradient(180deg, #635BFF, #635BFF)",
                },
              }}
              onClick={handleOccupancy}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#2A4D8F",
                  letterSpacing: 0.5,
                }}
              >
                Occupancy Summary
              </Typography>
              <ArrowForwardIcon sx={{ color: '#2A4D8F', fontSize: 28 }} />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                borderRadius: 2,
                background: "#ffffff",
                border: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 3px 12px rgba(0,0,0,0.06)",
                transition: "all 0.25s ease",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "6px",
                  background: "linear-gradient(180deg, #2A4D8F, #4F7DDC)",
                },
              }}
              onClick={handleClickList}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#2A4D8F",
                  letterSpacing: 0.5,
                }}
              >
                Upcoming Check-In List
              </Typography>
              <ArrowForwardIcon sx={{ color: '#2A4D8F', fontSize: 28 }} />
            </Box>
          </Grid>

          {/* Check-out Card */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                borderRadius: 2,
                background: "#ffffff",
                border: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 3px 12px rgba(0,0,0,0.06)",
                transition: "all 0.25s ease",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "6px",
                  background: "linear-gradient(180deg, #D35400, #FF9F45)",
                },
              }}
              onClick={handclickCheckout}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#D35400",
                  letterSpacing: 0.5,
                }}
              >
                Upcoming Check-Out List
              </Typography>
              <ArrowForwardIcon sx={{ color: '#D35400', fontSize: 28 }} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default SpeedometerGauge1;